<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      Seus dados
    </div>
    <div class="panel-body">
      <form>
        <div class="form-group">
          <label for="mediaFormName">Seu Nome</label>
          <input
            id="mediaFormName"
            v-model="mediaForm.name"
            type="text"
            class="form-control"
            @input="updateForm"
          >
        </div>
        <div class="form-group">
          <label for="mediaFormOrganization">Para quem você trabalha?</label>
          <input
            id="mediaFormOrganization"
            v-model="mediaForm.organization"
            type="text"
            class="form-control"
            @input="updateForm"
          >
        </div>
        <div class="form-group">
          <label for="mediaFormIsClosingAlert">O veículo que você vai sugerir fechou?</label>
          <select
            id="mediaFormIsClosingAlert"
            v-model="mediaForm.is_closing_alert"
            class="form-control"
            @change="updateForm"
          >
            <option
              v-for="opt in closingAlertOptions"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.text }}
            </option>
          </select>
        </div>
        <div
          v-show="mediaForm.is_closing_alert"
          class="form-group"
        >
          <label>Quando o veículo fechou?</label>
          <month-year-input
            v-model="mediaForm.closing_date"
            @input="updateForm"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
    import MonthYearInput from './MonthYearInput'
    export default {
        components: {MonthYearInput},
        data: () => ({
            mediaForm: {
                name: null,
                organization: null,
                is_closing_alert: false,
                closing_date: null
            },
            closingAlertOptions: [
                {text: 'Sim', value: true},
                {text: 'Não', value: false}
            ]
        }),
        methods: {
            updateForm () {
                this.$emit('input', this.mediaForm)
            }
        }
    }
</script>

<style scoped>

</style>
